/**
 * Composition root for data access. UI code imports `repo` (or uses useRepository())
 * and never knows which backend is active.
 */
import { env } from '@/config/env';
import type { DataRepository } from './repository';
import { DemoRepository } from './demo/demoRepository';
import { SupabaseRepository } from './supabase/supabaseRepository';
import { getSupabase } from '@/lib/supabaseClient';

function createRepository(): DataRepository {
  if (env.isSupabaseConfigured) return new SupabaseRepository(getSupabase());
  return new DemoRepository();
}

export const repo: DataRepository = createRepository();
export const isDemoMode = repo.mode === 'demo';

export * from './repository';
